<script>
import Layout from "@/router/layouts/main";
import { api } from "@/state/services";
import { VclList } from "vue-content-loading";
import Calendar from "primevue/calendar";
import { exportRowsToExcel } from "@/utils/export-excel";

export default {
  locales: {
    en: {},
    pt: {
      "We apologize, we are unable to retrieve information at this time. Please try again later.":
        "Pedimos desculpas, nao podemos recuperar informacoes no momento. Por favor, tente novamente mais tarde.",
      "No records found.": "Nenhum registro encontrado.",
    },
    es: {
      "We apologize, we are unable to retrieve information at this time. Please try again later.":
        "Nos disculpamos, no podemos recuperar informacion en este momento. Por favor, intentelo de nuevo mas tarde.",
      "No records found.": "No se encontraron registros.",
    },
  },
  components: {
    Layout,
    VclList,
    Calendar,
  },
  data() {
    return {
      loading: true,
      errored: false,
      empty: false,
      regional: "team",
      status: "all",
      total: 0,
      baseFields: [
        { key: "status", label: "Status" },
        { key: "level", label: "Nivel" },
        { key: "name", label: "Consultor" },
        { key: "client", label: "Cliente" },
        { key: "plate", label: "Placa" },
        { key: "chassi", label: "Chassi" },
        { key: "date_contract", label: "Contrato" },
        { key: "date_start", label: "Vigencia" },
        { key: "date_expiration", label: "1o Boleto" },
      ],
      items: null,
      sortBy: "date",
      sortDesc: false,
      currentPage: 1,
      perPage: "25",
      periodMonth: new Date(),
      filterType: "Cliente",
      clientFilter: "",
      consultorFilter: "",
      regionalFilter: "",
      totalBonus: 0,
      update: "",
    };
  },
  computed: {
    availableFilterTypes() {
      return this.regional === "all"
        ? ["Cliente", "Consultor", "Regional"]
        : ["Cliente", "Consultor"];
    },
    tableFields() {
      const fields = [...this.baseFields];

      if (this.regional === "all") {
        fields.splice(3, 0, { key: "regional", label: "Regional" });
      }

      return fields;
    },
    filteredItems() {
      if (!this.items) return [];

      const search = this.getSearchQuery().trim().toLowerCase();
      if (!search) return this.items;

      return this.items.filter((item) => {
        if (this.filterType === "Consultor") {
          return item.name && item.name.toLowerCase().includes(search);
        }

        if (this.filterType === "Regional") {
          return item.regional && item.regional.toLowerCase().includes(search);
        }

        return item.client && item.client.toLowerCase().includes(search);
      });
    },
  },
  methods: {
    getPeriod() {
      const baseDate = this.periodMonth ? new Date(this.periodMonth) : new Date();
      return [baseDate.getFullYear(), baseDate.getMonth() + 1].join("-");
    },
    showPeriod() {
      const baseDate = this.periodMonth ? new Date(this.periodMonth) : new Date();
      return [baseDate.getMonth() + 1, baseDate.getFullYear()].join("/");
    },
    getSearchQuery() {
      if (this.filterType === "Consultor") return this.consultorFilter;
      if (this.filterType === "Regional") return this.regionalFilter;
      return this.clientFilter;
    },
    getSearchType() {
      if (this.filterType === "Consultor") return "consultor";
      if (this.filterType === "Regional") return "regional";
      return "cliente";
    },
    getList() {
      this.items = null;
      this.loading = true;
      this.errored = false;
      this.empty = false;

      api
        .get(
          "apvs/truck/adesoes?date=" +
            this.getPeriod() +
            "&regional=" +
            this.regional +
            "&status=" +
            this.status +
            "&searchQuery=" +
            encodeURIComponent(this.getSearchQuery()) +
            "&searchType=" +
            this.getSearchType()
        )
        .then((response) => {
          if (response.data.status === "success") {
            this.items = response.data.list;
            this.total = response.data.list.length;
            this.totalBonus = response.data.total;
            this.update = response.data.update;
          }
        })
        .catch((error) => {
          this.errored = error;
        })
        .finally(() => {
          this.loading = false;
          if (this.items === "" || this.items == null) {
            this.empty = true;
          }
        });
    },
    exportExcel() {
      exportRowsToExcel(
        `apvs-truck-adesoes-${this.getPeriod()}`,
        this.tableFields,
        this.filteredItems
      );
    },
  },
  mounted() {
    this.getList();
  },
  watch: {
    regional() {
      if (this.regional !== "all" && this.filterType === "Regional") {
        this.filterType = "Cliente";
        this.regionalFilter = "";
      }
      this.currentPage = 1;
      this.getList();
    },
    status() {
      this.currentPage = 1;
      this.getList();
    },
    periodMonth() {
      this.currentPage = 1;
      this.getList();
    },
  },
};
</script>

<template>
  <Layout>
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <router-link tag="a" to="/">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);">
            <path d="M5 22h14a2 2 0 0 0 2-2v-9a1 1 0 0 0-.29-.71l-8-8a1 1 0 0 0-1.41 0l-8 8A1 1 0 0 0 3 11v9a2 2 0 0 0 2 2zm5-2v-5h4v5zm-5-8.59 7-7 7 7V20h-3v-5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v5H5z"></path>
          </svg>
        </router-link>
      </li>
      <li class="breadcrumb-item">APVS Truck</li>
      <li class="breadcrumb-item d-none d-sm-block">Adesoes</li>
    </ol>

    <div class="page-title-box d-flex justify-content-between mb-3">
      <div>
        <h3>Adesoes</h3>
        <p></p>
      </div>
      <div class="d-flex align-items-start" style="gap: 10px;">
        <button class="btn btn-success" @click="exportExcel">
          <i class="bx bx-download font-size-18 align-middle mr-1"></i>
          Exportar Excel
        </button>
        <div v-if="update" class="font-size-11 text-right" style="line-height: 15px;">
          <div class="text-secondary">ULTIMA ATUALIZACAO</div>
          <div class="text-secondary">{{ update }}</div>
        </div>
      </div>
    </div>

    <div class="filter-bar d-flex mb-2">
      <div class="totals">
        <h6 class="m-0 text-secondary">total de adesoes</h6>
        <div>{{ totalBonus }}</div>
      </div>
      <b-dropdown variant="outline-light">
        <template #button-content>
          <div class="d-flex justify-content-between align-items-center">
            <div>
              <h6 class="m-0 text-secondary">Equipe</h6>
              <div v-if="regional === 'all'">Toda rede</div>
              <div v-else>Minha regional</div>
            </div>
            <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path d="m12 14.168-5.582-5.61L5 9.967 12 17l7-7-1.415-1.414L12 14.168Z" fill="currentColor"></path>
            </svg>
          </div>
        </template>
        <b-dropdown-form><b-form-radio v-model="regional" value="all">Toda rede</b-form-radio></b-dropdown-form>
        <b-dropdown-form><b-form-radio v-model="regional" value="team">Minha regional</b-form-radio></b-dropdown-form>
      </b-dropdown>
      <b-dropdown variant="outline-light">
        <template #button-content>
          <div class="d-flex justify-content-between align-items-center">
            <div>
              <h6 class="m-0 text-secondary">Status</h6>
              <div v-if="status === 'all'">Todos</div>
              <div v-else-if="status === 'Pendente'">Pendente</div>
              <div v-else-if="status === 'Quitado'">Quitado</div>
              <div v-else-if="status === 'Cancelado'">Cancelado</div>
            </div>
            <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path d="m12 14.168-5.582-5.61L5 9.967 12 17l7-7-1.415-1.414L12 14.168Z" fill="currentColor"></path>
            </svg>
          </div>
        </template>
        <b-dropdown-form><b-form-radio v-model="status" value="all">Todos</b-form-radio></b-dropdown-form>
        <b-dropdown-form><b-form-radio v-model="status" value="Pendente">Pendente</b-form-radio></b-dropdown-form>
        <b-dropdown-form><b-form-radio v-model="status" value="Quitado">Quitado</b-form-radio></b-dropdown-form>
        <b-dropdown-form><b-form-radio v-model="status" value="Cancelado">Cancelado</b-form-radio></b-dropdown-form>
      </b-dropdown>
      <b-dropdown variant="outline-light">
        <template #button-content>
          <div class="d-flex justify-content-between align-items-center">
            <div>
              <h6 class="m-0 text-secondary">Filtrar periodo</h6>
              <div>{{ showPeriod() }}</div>
            </div>
            <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path d="m12 14.168-5.582-5.61L5 9.967 12 17l7-7-1.415-1.414L12 14.168Z" fill="currentColor"></path>
            </svg>
          </div>
        </template>
        <b-dropdown-group>
          <Calendar v-model="periodMonth" view="month" dateFormat="yy-mm-dd" inline style="width: 250px;"></Calendar>
        </b-dropdown-group>
      </b-dropdown>
      <b-dropdown variant="outline-light">
        <template #button-content>
          <div class="d-flex justify-content-between align-items-center">
            <div>
              <h6 class="m-0 text-secondary">Itens por pagina</h6>
              <div>{{ perPage }} itens</div>
            </div>
            <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path d="m12 14.168-5.582-5.61L5 9.967 12 17l7-7-1.415-1.414L12 14.168Z" fill="currentColor"></path>
            </svg>
          </div>
        </template>
        <b-dropdown-form><b-form-radio v-model="perPage" value="10">10 itens</b-form-radio></b-dropdown-form>
        <b-dropdown-form><b-form-radio v-model="perPage" value="25">25 itens</b-form-radio></b-dropdown-form>
        <b-dropdown-form><b-form-radio v-model="perPage" value="50">50 itens</b-form-radio></b-dropdown-form>
        <b-dropdown-form><b-form-radio v-model="perPage" value="100">100 itens</b-form-radio></b-dropdown-form>
      </b-dropdown>
    </div>

    <div class="filter-bar d-flex mb-4">
      <div class="d-flex align-items-start w-100 filter-bar-row">
        <b-dropdown variant="outline-light" class="pt-1 filter-bar-type">
          <template #button-content>
            <div class="d-flex justify-content-between align-items-center">
              <div>
                <h6 class="m-0 text-secondary">Filtrar por</h6>
                <div class="text-capitalize">{{ filterType }}</div>
              </div>
              <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <path d="m12 14.168-5.582-5.61L5 9.967 12 17l7-7-1.415-1.414L12 14.168Z" fill="currentColor"></path>
              </svg>
            </div>
          </template>
          <b-dropdown-form v-for="type in availableFilterTypes" :key="type">
            <b-form-radio v-model="filterType" :value="type">{{ type }}</b-form-radio>
          </b-dropdown-form>
        </b-dropdown>
        <div class="d-flex flex-column flex-fill pt-1">
          <input v-if="filterType === 'Cliente'" v-model="clientFilter" type="text" class="form-control search" aria-label="Digite o nome do cliente" placeholder="Digite o nome do cliente" />
          <input v-else-if="filterType === 'Consultor'" v-model="consultorFilter" type="text" class="form-control search" aria-label="Digite o nome do consultor" placeholder="Digite o nome do consultor" />
          <input v-else v-model="regionalFilter" type="text" class="form-control search" aria-label="Digite o nome da regional" placeholder="Digite o nome da regional" />
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-body min-vh-25">
        <div class="error text-center min-vh-25" v-if="errored">
          Pedimos desculpas, nao podemos recuperar informacoes neste momento. Por favor, tente novamente mais tarde.
        </div>
        <vcl-list v-else-if="loading" class="col-md-6"></vcl-list>
        <div v-else-if="items && items.length === 0" class="empty text-center min-vh-25 d-flex align-items-center justify-content-center">
          <strong>Nenhuma movimentacao no periodo.</strong>
        </div>
        <div v-else class="table-responsive">
          <b-table stacked="md"
            :items="filteredItems"
            :fields="tableFields"
            class="table-nowrap table-style table-hover min-vh-25"
            head-variant="light"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :current-page="currentPage"
            :per-page="perPage"
            responsive
          >
            <template #cell(status)="row">
              <span v-if="row.item.status === 'Pendente'" class="badge badge-soft-warning p-2 font-size-12 font-weight-bold text-uppercase">Pendente</span>
              <span v-else-if="row.item.status === 'Quitado'" class="badge badge-soft-success p-2 font-size-12 font-weight-bold text-uppercase">Quitado</span>
              <span v-else-if="row.item.status === 'Cancelado'" class="badge badge-soft-danger p-2 font-size-12 font-weight-bold text-uppercase">Cancelado</span>
            </template>
          </b-table>
        </div>
        <b-pagination class="m-0 mt-3" v-model="currentPage" :total-rows="filteredItems.length" :per-page="perPage" pills align="center"></b-pagination>
      </div>
    </div>
  </Layout>
</template>
